module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-00.2.08192dc6.jpg";